import {Action} from "redux";
import {
    StartPollingMessageRoomsByCustomerResponse
} from "../response/message_room_response";

export enum CustomerMessageRoomsActionType {

    REQUEST_START_POLLING_MESSAGE_ROOMS = "CUSTOMER_MESSAGE_ROOMS_REQUEST_START_POLLING_MESSAGE_ROOMS",
    CALLBACK_START_POLLING_MESSAGE_ROOMS = "CUSTOMER_MESSAGE_ROOMS_CALLBACK_START_POLLING_MESSAGE_ROOMS",
    REQUEST_STOP_POLLING_MESSAGE_ROOMS = "CUSTOMER_MESSAGE_ROOMS_REQUEST_STOP_POLLING_MESSAGE_ROOMS",
}

export interface IRequestStartPollingMessageRoomsByCustomerMessageRoomsAction extends Action {
    type: CustomerMessageRoomsActionType.REQUEST_START_POLLING_MESSAGE_ROOMS;
}

export interface ICallbackStartPollingMessageRoomsByCustomerMessageRoomsAction extends Action {
    type: CustomerMessageRoomsActionType.CALLBACK_START_POLLING_MESSAGE_ROOMS;
    isSuccess: boolean;
    item?: StartPollingMessageRoomsByCustomerResponse;
    error?: any;
}

export interface IRequestStopPollingMessageRoomsByCustomerMessageRoomsAction extends Action {
    type: CustomerMessageRoomsActionType.REQUEST_STOP_POLLING_MESSAGE_ROOMS;
}

export type CustomerMessageRoomsAction =
    IRequestStartPollingMessageRoomsByCustomerMessageRoomsAction |
    ICallbackStartPollingMessageRoomsByCustomerMessageRoomsAction |
    IRequestStopPollingMessageRoomsByCustomerMessageRoomsAction
    ;

export interface ICustomerMessageRoomsActionCreator {

    requestStartPollingMessageRoomsAction(): IRequestStartPollingMessageRoomsByCustomerMessageRoomsAction;

    callbackStartPollingMessageRoomsAction(
        isSuccess: boolean,
        item?: StartPollingMessageRoomsByCustomerResponse,
        error?: any,
    ): ICallbackStartPollingMessageRoomsByCustomerMessageRoomsAction;

    requestStopPollingMessageRoomsAction(): IRequestStopPollingMessageRoomsByCustomerMessageRoomsAction;
}

class ActionCreator implements ICustomerMessageRoomsActionCreator {

    public requestStartPollingMessageRoomsAction = (): IRequestStartPollingMessageRoomsByCustomerMessageRoomsAction => {
        return {
            type: CustomerMessageRoomsActionType.REQUEST_START_POLLING_MESSAGE_ROOMS,
        };
    };

    public callbackStartPollingMessageRoomsAction = (
        isSuccess: boolean,
        item?: StartPollingMessageRoomsByCustomerResponse,
        error?: any,
    ): ICallbackStartPollingMessageRoomsByCustomerMessageRoomsAction => {
        return {
            type: CustomerMessageRoomsActionType.CALLBACK_START_POLLING_MESSAGE_ROOMS,
            isSuccess,
            item,
            error,
        };
    };

    public requestStopPollingMessageRoomsAction = (): IRequestStopPollingMessageRoomsByCustomerMessageRoomsAction => {
        return {
            type: CustomerMessageRoomsActionType.REQUEST_STOP_POLLING_MESSAGE_ROOMS,
        };
    };
}

export const createCustomerMessageRoomsActionCreator = (): ICustomerMessageRoomsActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_message_rooms_action.ts